import { BrowserRouter, Route, Routes } from 'react-router-dom';

import AppView from './AppView';
import PrivateRoute from './PrivateRoute';
import RouteConfig from './RouteConfig';
import routePaths from './routePaths';

const AppRoute = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={routePaths.login}
          element={<RouteConfig.login.component />}
        />
        <Route
          path={routePaths.oktaSso}
          element={<RouteConfig.oktaSso.component />}
        />
        <Route
          path={routePaths.logout}
          element={<RouteConfig.logout.component />}
        />
        {/* The private route has different fall backs based on the login method, so we removed the fallback property 
            from the route definition here and handle the fall back logic inside the PrivateRoute code */}
        <Route
          path="/*"
          element={<PrivateRoute component={AppView} />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;
